import {Component, HostListener, OnInit} from '@angular/core';
// @ts-ignore
import $ from 'jquery';

// import $ = require('jquery');

@Component({
  selector: 'app-brico-footer',
  templateUrl: './brico-footer.component.html',
  styleUrls: ['./brico-footer.component.css']
})
export class BricoFooterComponent implements OnInit {

  smallScreen = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  @HostListener('window:resize', ['$event'])
  onResizeEvent(event): void {
    this.onResize();
    // console.log("ee")
    // console.log(event.target.innerWidth)
  }

  // window.onresize = function (event) {
  //   onResize();
  // };

  public onResize(): void {
    const width = window.innerWidth;
    if (width < 768) {
      $('.footer-group-item-caret').each(function() {
        const html = $(this).html().replace('fa-angle-up', 'fa-angle-down');
        $(this).html(html);
        $(this).show();
      });
      $('.footer-group-items-container').hide();
      $('.footer-hr').show();
    } else {
      $('.footer-group-items-container').show();
      $('.footer-group-item-caret').hide();
      $('.footer-hr').hide();
    }
  }

//   window;
// .
//   onresize = function(event) {
//     onResize();
//   };
//   function;
//
//   toggleFooter(sender, toggleId) {
//     if (sender.innerHTML.includes('fa-angle-down')) {
//       sender.innerHTML = sender.innerHTML.replace('fa-angle-down', 'fa-angle-up');
//     } else {
//       sender.innerHTML = sender.innerHTML.replace('fa-angle-up', 'fa-angle-down');
//     }
//
//     $('#' + toggleId).toggle();
//   }
}
